export default "__VITE_ASSET__6ecf2370__"